var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('MotorS',{attrs:{"cp":this.$route,"childrens":this.$route.meta.childrens,"idTela":_vm.getIdTela()},on:{"register":_vm.register}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }